import React from "react";
import styled from "../style.module.css";
import { ACCENTS } from "./theme";

// Single horizontal 100%-stacked bar with a legend — compact composition view
// (e.g. entitlement status: active / expired / pending).
const StackedBar = ({ title, rows, formatValue, emptyHint, asOf = true }) => {
  const data = (rows || []).filter((r) => Number(r.value) > 0);
  const total = data.reduce((s, r) => s + Number(r.value), 0);

  return (
    <div className={styled.chartCard}>
      <div className={styled.chartCardHead}>
        <h3 className={styled.chartTitle}>{title}</h3>
        {asOf && <span className={styled.asOfTag}>Live</span>}
      </div>
      {data.length > 0 ? (
        <>
          <div className={styled.stackTrack}>
            {data.map((r, i) => (
              <div
                key={i}
                className={styled.stackSeg}
                style={{ width: `${(Number(r.value) / total) * 100}%`, background: ACCENTS[i % ACCENTS.length] }}
                title={`${r.label}: ${formatValue ? formatValue(r.value) : r.value}`}
              />
            ))}
          </div>
          <div className={styled.stackLegend}>
            {data.map((r, i) => (
              <div key={i} className={styled.stackLegendItem}>
                <span className={styled.stackDot} style={{ background: ACCENTS[i % ACCENTS.length] }} />
                <span className={styled.stackLegendLabel}>{r.label}</span>
                <span className={styled.stackLegendValue}>{formatValue ? formatValue(r.value) : r.value}</span>
              </div>
            ))}
          </div>
        </>
      ) : (
        <p className={styled.emptyHint}>{emptyHint || "No data yet."}</p>
      )}
    </div>
  );
};

export default StackedBar;
